import React from "react"
import { faNewspaper } from "@fortawesome/free-solid-svg-icons/faNewspaper"

import COPY from "~config/copy-constants"
import Tag from "~components/shared/todo-lib-react-components/tag"
import type { ListingType } from "~graphql/generated/graphql"
import { isLodgingOnlyType } from "~utils/listing-helpers"

interface Props {
    readonly listingType?: ListingType | null
    readonly licenseRequired?: boolean | null
}

export default function ListingLicensePill({
    listingType,
    licenseRequired,
}: Props) {
    const licenseRequiredText = licenseRequired
        ? COPY.LICENSE_REQUIRED
        : COPY.LICENSE_OPTIONAL

    if (isLodgingOnlyType(listingType)) return null

    return <Tag leftIcon={faNewspaper}>{licenseRequiredText}</Tag>
}
